document.addEventListener('DOMContentLoaded', function () {
    const scrollableElement = document.querySelector('.category-list__slider ul');
    const scrollableWrap = document.querySelector('.category-list__slider');

    if (scrollableElement) {
        scrollableElement.addEventListener('scroll', function () {
            const isScrolledToEnd = scrollableElement.scrollLeft + scrollableElement.clientWidth + 0.5 >= scrollableElement.scrollWidth;
            if (isScrolledToEnd) {
                scrollableWrap.classList.add('scrolled');
            } else {
                scrollableWrap.classList.remove('scrolled');
            }
        });
    }

// sticky category list
    const categoryList = document.querySelector(".category-list");
    const header = document.querySelector("header");

    if (categoryList && header) {
        const headerHeight = header.offsetHeight;
        const originalOffset = categoryList.offsetTop;
        let placeholder = null;
        let lastScrollTop = 0;
        let ticking = false;

        const onScroll = () => {
            const currentScrollTop = window.scrollY;

            if (currentScrollTop > lastScrollTop) {
                if (!placeholder && (currentScrollTop + headerHeight) >= originalOffset) {
                    placeholder = document.createElement('div');
                    placeholder.style.height = `${categoryList.clientHeight}px`;
                    placeholder.style.visibility = 'hidden';
                    placeholder.style.margin = 'unset';

                    categoryList.classList.add('sticky');
                    categoryList.style.top = `${headerHeight}px`;
                    categoryList.insertAdjacentElement('afterend', placeholder);
                }
            } else {
                if (placeholder && (currentScrollTop + headerHeight) <= originalOffset) {
                    placeholder.remove();
                    placeholder = null;

                    categoryList.classList.remove('sticky');
                }
            }

            lastScrollTop = currentScrollTop;
            ticking = false;
        };

        window.addEventListener("scroll", () => {
            if (!ticking) {
                requestAnimationFrame(onScroll);
                ticking = true;
            }
        });
    }
});
